import { Button, FormGroup, Modal, ModalBody, ModalHeader } from 'reactstrap';
import styles from 'src/pages/accueil/styles/style-project.module.scss';

export const GlobalModal = ({ children, isOpen, toggle, t, onSubmit, modelHeaderName, selected }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{modelHeaderName}</ModalHeader>
      <ModalBody>
        <form className="needs-validation" noValidate onSubmit={onSubmit}>
          <FormGroup className="form-row">{children}</FormGroup>

          <Button outline color="success" className="float-right" type="submit" disabled={!selected}>
            {t('save')}
          </Button>
          <Button className={styles['btn-cancel']} onClick={toggle}>
            {t('cancel')}
          </Button>
        </form>
      </ModalBody>
    </Modal>
  );
};
